<template>
  <Head v-if="flat">
    <title v-if="!flat.title">
      {{ flatNameNormalize(flat.layout) }}
      {{ flat.layout.area }} м² / {{ flat.floor.number }} этаж в ЖК Сенсация
      (№{{ flat.number }})
    </title>
    <meta
      name="description"
      content="Выберите понравившуюся вам планировку в ЖК «Сенсация» от застройщика ГК ОСНОВА."
    />
  </Head>
  <main class="main">
    <div class="container">
      <Backlink :to="backlink" :text="backlink.title" />
    </div>
    <div
      v-if="flat"
      class="plan-flat"
      :class="{ 'commerce-flat': $route.meta.isCommerce }"
    >
      <div class="flat">
        <div class="container">
          <div class="row">
            <div class="col-lg order-lg-1">
              <div class="flat__right">
                <div class="flat-tabs">
                  <div
                    :class="{
                      'flat-tabs__tab': flatsTab !== 1,
                      'flat-tabs__tab flat-tabs__tab_active': flatsTab === 1,
                    }"
                    @click="toggleTabs(1)"
                  >
                    Планировка
                  </div>
                  <div
                    :class="{
                      'flat-tabs__tab': flatsTab !== 2,
                      'flat-tabs__tab flat-tabs__tab_active': flatsTab === 2,
                    }"
                    @click="toggleTabs(2)"
                  >
                    На этаже
                  </div>
                  <div
                    v-if="windowRenderImg && windowRenderImg.source"
                    :class="{
                      'flat-tabs__tab': flatsTab !== 3,
                      'flat-tabs__tab flat-tabs__tab_active': flatsTab === 3,
                    }"
                    @click="toggleTabs(3)"
                  >
                    Вид из окна
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl">
                    <div class="plan__wrap">
                      <div
                        v-if="flat.layout.plan_image && flatsTab === 1"
                        class="flat__plan plan"
                      >
                        <FlatPlan
                          :plan-image="flat.layout.plan_image"
                          :flat="flat"
                          :filters="$filters"
                        />
                      </div>
                      <div
                        v-if="flat.floor.plan_image && flatsTab === 2"
                        class="flat__floor floor"
                      >
                        <FlatFloor
                          :img-source="flat.floor.plan_image.source"
                          :img-width="flat.floor.plan_image.width"
                          :img-height="flat.floor.plan_image.height"
                          :alt-text="'Расположение на этаже'"
                          :all-flats="allFlats"
                          :current-flat-uuid="flat.uuid"
                          :current-flat-title="
                            flat.title ||
                            flatNameNormalize(flat.layout) + ', №' + flat.number
                          "
                          :area-points="flat.area_points"
                        />
                      </div>
                      <div
                        v-if="
                          flatsTab === 3 &&
                          windowRenderImg &&
                          windowRenderImg.source
                        "
                        class="flat__window-render"
                      >
                        <FlatWindowRender
                          :plan-image="windowRenderImg"
                          :flat="flat"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-auto order-lg-0">
              <div class="flat__left">
                <h1 :class="['flat__title', 'h4', { mb: showTags }]">
                  {{
                    flat.title ? flat.title : flatNameNormalize(flat.layout)
                  }},
                  {{ "№" + flat.number }}
                </h1>
                <div v-if="!mq.xs" class="flat__favourite">
                  <FavouritesIcon :id="flat.id" />
                </div>
                <div v-if="showTags" class="flat__tags">
                  <div
                    v-if="flat.status === 'booked'"
                    class="flat__tag btn btn-tag btn-tag-default"
                  >
                    <Icon icon="lock2" />{{
                      $filters.bookedStatusNormalize(flat.layout.type)
                    }}
                  </div>
                  <div
                    v-if="flat.properties._with_layout_furniture"
                    class="flat__tag btn btn-tag btn-lime btn-new"
                  >
                    <Icon icon="roller" />отделка + мебель
                  </div>
                  <div
                    v-if="flat.properties._with_layout"
                    class="flat__tag btn btn-tag btn-lime btn-new"
                  >
                    <Icon icon="roller" />доступна отделка
                  </div>
                  <div
                    v-if="flat.properties.is_assignment"
                    class="flat__tag btn btn-tag btn-dark-grey"
                  >
                    <Icon icon="key" />переуступка
                  </div>
                  <div
                    v-if="flat.properties?.without_down_payment"
                    class="flat__tag btn btn-tag btn-tag-red"
                  >
                    Без первого взноса
                  </div>
                  <div
                    v-if="flat?.properties?.castom_sticker_2"
                    class="flat__tag btn btn-tag btn-tag-red"
                    v-html="flat?.properties?.castom_sticker_2"
                  />
                </div>
                <div v-if="tourRender" class="flat__tour">
                  <TourButton :tour-render="tourRender" />
                </div>
                <div class="flat__info info">
                  <div v-if="flat.layout.area" class="info__row">
                    <div class="info__td">
                      <span>Общая площадь</span>
                    </div>
                    <div class="info__td">
                      <span v-html="$filters.squareFormat(flat.layout.area)" />
                    </div>
                  </div>
                  <div v-if="sortedRooms" class="info-small">
                    <div
                      v-for="room in sortedRooms"
                      :key="room.number"
                      class="info__row"
                    >
                      <div class="info__td">
                        <span>{{ room.number }}. {{ room.name }}</span>
                      </div>
                      <div class="info__td">
                        <span v-html="$filters.squareFormat(room.area)" />
                      </div>
                    </div>
                  </div>
                  <div v-if="flat.floor" class="info__row">
                    <div class="info__td">
                      <span>Этаж</span>
                    </div>
                    <div class="info__td">
                      <span>{{ flat.floor.number }}</span>
                    </div>
                  </div>
                  <div v-if="flat.building" class="info__row">
                    <div class="info__td">
                      <span>Корпус</span>
                    </div>
                    <div class="info__td">
                      <span>{{ displayBuilding }}</span>
                    </div>
                  </div>
                  <div v-if="flat.meter_cost" class="info__row">
                    <div class="info__td">
                      <span>Цена за м&sup2;</span>
                    </div>
                    <div class="info__td">
                      <template
                        v-if="flat.properties?.reverse_discount_percent > 0"
                      >
                        <span class="price__cost-new">{{
                          $filters.priceFormat(flat.discount_meter_cost)
                        }}</span>
                        <span
                          :class="{
                            'price__cost-old':
                              flat.properties?.reverse_discount_percent > 0,
                          }"
                          >{{ $filters.priceFormat(flat.meter_cost) }}</span
                        >
                      </template>
                      <template v-else>
                        <span v-if="flat.discount" class="price__cost-new">{{
                          $filters.priceFormat(flat.discount_meter_cost)
                        }}</span>
                        <span :class="{ 'price__cost-old': flat.discount }">{{
                          $filters.priceFormat(flat.meter_cost)
                        }}</span>
                      </template>
                    </div>
                  </div>
                  <div v-if="!$route.meta.isCommerce" class="info__row">
                    <div class="info__td">
                      <span>Ипотека</span>
                    </div>
                    <div class="info__td primary">
                      <span>
                        от
                        {{
                          $filters.priceFormat(
                            $filters.mortgagePay({
                              cost: flat.cost,
                              initPay:
                                flat.cost *
                                (mortgage[`rate_for_${flat.layout.type}s`]
                                  .initial_instalment /
                                  100),
                              applyCoef: mortgage.apply_coefficient,
                              coef: mortgage.coefficient,
                              percent:
                                mortgage[`rate_for_${flat.layout.type}s`].rate,
                              firsYearCoefficient:
                                mortgage[`rate_for_${flat.layout.type}s`]
                                  .first_year_rate,
                              years: mortgage.max_mortgage_bank_time,
                            })
                          )
                        }}&nbsp;/&nbsp;мес.
                      </span>
                      <span v-if="mortgageFootnote" class="mortgage__mark"
                        >*</span
                      >
                    </div>
                  </div>
                  <div v-if="flat.status" class="info__row">
                    <div class="info__td">
                      <span>Статус</span>
                    </div>
                    <div
                      class="info__td"
                      :class="{ 'info__td--green': flat.status === 'booked' }"
                    >
                      <span>{{ statusNormalize(flat.status) }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="!flat.rent && flat.cost" class="flat__price price">
                  <div class="price-cost__wrapper">
                    <div class="price__label">Стоимость</div>
                    <div class="price__cost">
                      <template
                        v-if="flat.properties?.reverse_discount_percent > 0"
                      >
                        <span class="price__cost-new">{{
                          $filters.priceFormat(getFlatCosts(flat).cost)
                        }}</span>
                        <span
                          :class="{
                            'price__cost-old':
                              flat.properties?.reverse_discount_percent > 0,
                          }"
                          >{{
                            $filters.priceFormat(getFlatCosts(flat).oldCost)
                          }}</span
                        >
                      </template>
                      <template v-else>
                        <span v-if="flat.discount" class="price__cost-new">{{
                          $filters.priceFormat(flat.discount_cost)
                        }}</span>
                        <span :class="{ 'price__cost-old': flat.discount }">{{
                          $filters.priceFormat(flat.cost)
                        }}</span>
                      </template>
                      <template v-if="costFootnote">&nbsp;**</template>
                    </div>
                  </div>
                  <div class="price-buttons__mobile">
                    <div v-if="mq.xs" class="flat__favourite">
                      <FavouritesIcon :id="flat.id" />
                    </div>
                    <Share
                      v-if="mq.xs"
                      :flat-number="flat.number"
                      class="flat__share"
                    />
                  </div>
                  <!-- <DocsButton
                    v-if="
                      flat.discount || flat.properties?.reverse_discount_percent
                    "
                  /> -->
                </div>
                <div v-if="flat.rent" class="flat__price price">
                  <div class="price__label">Стоимость</div>
                  <div class="price__cost">
                    <span>{{ $filters.priceFormat(flat.rent) }} / мес</span>
                  </div>
                </div>
                <div class="flat__btns d-sm-flex justify-content-lg-between">
                  <button
                    class="btn btn-default btn-small"
                    data-popup-with-chats
                    data-popup-with-chats-title="Заказать звонок"
                  >
                    Заказать звонок
                  </button>
                  <Share
                    v-if="!mq.xs"
                    :flat-number="flat.number"
                    class="flat__share"
                  />
                </div>
                <div
                  v-if="mortgageFootnote || costFootnote"
                  class="flat__footnote"
                >
                  <p v-if="mortgageFootnote" v-html="mortgageFootnote" />
                  <p v-if="costFootnote" v-html="costFootnote" />
                </div>
                <Feats
                  v-if="flat.properties"
                  class="flat__feats"
                  :list="$route.meta.isCommerce ? flat.properties.props : null"
                  :properties="flat.properties"
                />
                <Mortgage
                  v-if="!$route.meta.isCommerce && !isApartment"
                  class="flat__mortgage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import _orderBy from "lodash/orderBy";
import Backlink from "@/components/UI/Backlink.vue";
import Feats from "@/components/flat/FlatFeats.vue";
import Share from "@/components/flat/FlatShare.vue";
import FlatPlan from "@/components/flat/FlatPlan.vue";
import FlatFloor from "@/components/flat/FlatFloor.vue";
import FlatWindowRender from "@/components/flat/FlatWindowRender.vue";
import Mortgage from "@/components/flat/FlatMortgage.vue";
// import TradeIn from "@/components/flat/FlatTradeIn.vue";
import FavouritesIcon from "@/components/UI/FavouritesIcon.vue";
import TourButton from "@/components/UI/TourButton.vue";
// import DocsButton from "@/components/UI/DocsButton.vue";
// import BuildingsPlan from "@/components/planFloor/BuildingsPlan.vue";
// import FlatViewTrigger from "@/components/flat/FlatViewTrigger.vue";
// import flatsVideo from '@/content/flat.js'
// import commerceFlats from "@/content/commerce.js";
// import unicLots from "@/content/unicLots.js";
import { Head } from "@vueuse/head";
// import views from "../content/views";
import { getReversPercentCost } from "@/utils/getReversPercentCost";
import { viewProduct } from "@/mindbox";
export default {
  components: {
    Head,
    Backlink,
    Feats,
    Share,
    FlatPlan,
    FlatFloor,
    FlatWindowRender,
    Mortgage,
    // TradeIn,
    FavouritesIcon,
    TourButton,
    // DocsButton,
    // BuildingsPlan,
    // FlatViewTrigger,
  },
  inject: ["mq", "mainStore"],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.mq.mdMinus) {
        vm.backlink = { title: "К списку квартир", name: "PlanSearch" };
      } else if (from.name == "PlanSearch") {
        vm.backlink = { title: "Подбор по параметрам", name: "PlanSearch" };
      }
    });
  },
  data() {
    return {
      flat: null,
      allFlats: [],
      flatsTab: 1,
    };
  },
  computed: {
    showTags() {
      const { status, discount, properties, number, building } = this.flat;
      return (
        status === "booked" ||
        discount ||
        properties._with_layout ||
        properties._with_finished_layout ||
        properties._with_layout_furniture ||
        properties.with_design_project ||
        properties.is_assignment ||
        properties.without_down_payment ||
        properties.castom_sticker_2
      );
    },
    additionFlats() {
      return commerceFlats.concat(unicLots);
    },
    sortedRooms() {
      let result = "";
      if (this.flat.layout.variants.length > 0) {
        result = _orderBy(this.flat.layout.variants[0].rooms, "number", "asc");
      }
      return result;
    },
    commerceFlats() {
      return this.additionFlats;
    },
    backlink() {
      if (this.$route.meta.isUnic) {
        return {
          title: "Вернуться назад",
          name: "PlanUnicLotsSearch",
        };
      }
      if (this.$route.meta.isCommerce) {
        return {
          title: "Вернуться назад",
          name: "PlanCommerceSearch",
        };
      }
      if (this.$route.meta.isSearch) {
        return {
          title: "Вернуться назад",
          name: "PlanSearch",
        };
      }
      return {
        title: "Вернуться назад",
        name: "PlanSearch",
        params: {
          korp: this.$route.params.korp,
          floor: this.$route.params.floor,
        },
      };
    },
    isApartment() {
      return this.flat?.layout.type === "apartment";
    },
    mortgage() {
      return this.mainStore.state.data?.mortgage ?? {};
    },
    mortgageProps() {
      return this.mainStore.getMortgageProps();
    },
    videos() {
      if (!this.flat) {
        return null;
      }
      // return flatsVideo[this.flat.number]
    },
    mortgageFootnote() {
      return this.isApartment
        ? this.mortgage.footnote_apartment
        : this.mortgage.footnote;
    },
    costFootnote() {
      return this.flat.properties.cost_footnote ?? "";
    },
    viewWindows() {
      return this.mainStore.state.data?.general_views.view_windows ?? {};
    },
    tours() {
      return this.mainStore.state.data?.general_views["3d_tours"] ?? {};
    },
    windowRenderImg() {
      return (
        this.viewWindows.find(
          (item) =>
            item.building_number === this.flat.building &&
            item.section_number === this.flat.section &&
            item.flat_numbers
              .split(",")
              .map((item) => item.trim())
              .includes(this.flat.number)
        )?.image ?? {}
      );
    },
    tourRender() {
      return (
        this.tours.find(
          (item) =>
            item.building_number === this.flat.building &&
            item.section_number === this.flat.section &&
            item.flat_numbers
              .split(",")
              .map((item) => item.trim())
              .includes(this.flat.number)
        )?.url ?? null
      );
    },
    displayBuilding() {
      if (!this.flat) return "";

      const buildingNames = {
        1: "3.1",
        2: "2.1",
      };
      return buildingNames[this.flat.building] || this.flat.building;
    },
  },
  async mounted() {
    try {
      let flat = null;

      if (!this.$route.meta.isCommerce) {
        let data = await axios.get(
          this.$endpoint + "building-objects/property/" + this.$route.params.id
        );
        flat = data.data.data;
        await this.loadAllFlats(flat);
      } else {
        this.commerceFlats.forEach((item) => {
          if (item.uuid == this.$route.params.id) {
            flat = item;
            return;
          }
        });
      }
      // this.$addPlanStub(flat);
      this.flat = flat;
      viewProduct(this.flat?.uuid);
    } catch (err) {
      console.log(err);
      // this.$Progress.fail();
    } finally {
      // this.$Progress.finish();
    }
  },
  methods: {
    async loadAllFlats(currentFlat) {
      try {
        const response = await axios.get(
          `${this.$endpoint}building-objects/${this.$project}/floor/${currentFlat.building}/1/${currentFlat.floor.number}`
        );
        this.allFlats = response.data.data.flats.filter((flat) => flat?.layout?.plan_image?.image_thumb) || [];
      } catch (error) {
        console.error(error);
      }
    },
    flatNameNormalize({ type, room_count: roomCount }, declension = false) {
      const form = declension ? "declension" : "singular";
      switch (roomCount) {
        case "0":
        case "S": {
          const NAMES = {
            flat: {
              singular: "Квартира-студия",
              declension: "квартиры-студии",
            },
            apartment: {
              singular: "Студия",
              declension: "Студии",
            },
          };
          return NAMES[type]?.[form] ?? "";
        }
        default: {
          const POSTFIXES = {
            flat: {
              singular: "комнатная",
              declension: "комнатной",
            },
            apartment: {
              singular: "комнатный лот",
              declension: "комнатного лота",
            },
          };
          const postfix = POSTFIXES[type]?.[form];
          return postfix ? `${roomCount.replace("E", "")}-${postfix}` : "";
        }
      }
    },
    statusNormalize(status) {
      switch (status) {
        case "available":
          return "Свободно";
        case "booked":
          return "Забронировано";
        case "sold":
          return "Продано";
        default:
          return status;
      }
    },
    toggleTabs(tab) {
      this.flatsTab = tab;
    },
    getFlatCosts(flat) {
      return getReversPercentCost({ value: flat })
    },
  },
};
</script>

<style scoped>
main {
  overflow: hidden;
}

.row {
  align-items: baseline;
}

.flat {
  margin-bottom: 80px;
}

.flat:last-child {
  margin-bottom: 0;
}

.flat__title {
  margin-bottom: 48px;
  padding-right: 55px;
}

.flat__title.mb {
  margin-bottom: 12px;
}

.flat__tag {
  margin-right: 12px;
  margin-bottom: 5px;
}

.flat__tags {
  margin-bottom: 36px;
  display: flex;
  flex-wrap: wrap;
}

.flat__tag--stroke {
  background-color: #fff !important;
  color: #205640 !important;
  border-color: #205640 !important;
}

.flat__tour {
  margin-bottom: 40px;
}

.flat__favourite {
  position: absolute;
  top: 16px;
  right: 0;
}

.flat__favourite .favourite-icon {
  width: 44px;
  height: 44px;
}

.flat__left {
  position: relative;
  width: 375px;
  padding-top: 20px;
}

.flat__right {
  position: sticky;
  top: 196px;
}

.flat-tabs {
  position: relative;
  z-index: 2;
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.flat-tabs__tab {
  padding: 12px;
  color: #ff0020;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  font-size: 14px;
  font-weight: 500;
  transition: 0.3s;
}

.flat-tabs__tab:hover {
  cursor: pointer;
  background: #ff0020;
  color: #ffffff;
  transition: 0.3s;
}

.flat-tabs__tab.flat-tabs__tab_active {
  background: #ff0020;
  color: #ffffff;
}

.flat__sidebar {
  width: 195px;
  height: 100%;
}

.flat__sidebar:not(.flat__sidebar--curved)::before {
  content: "";
  height: 80px;
}

.flat__info {
  margin-bottom: 23px;
  padding-bottom: 23px;
  border-bottom: 1px solid #e5e5e5;
}

.flat__info:last-child {
  margin-bottom: 0;
}

.flat__info .info-small {
  padding-bottom: 8px;
  padding-left: 20px;
}

.flat__footnote {
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  color: #3f4440;
}

.flat__footnote p:first-child {
  margin: 0;
}

.flat__footnote p:last-child {
  margin-bottom: 27px;
}

.info__td.primary {
  font-weight: 500;
}

.info__td--green {
  color: #ff0020;
}

.price {
  margin-bottom: 25px;
}

.price:last-child {
  margin-bottom: 0;
}

.price__cost {
  font-weight: 500;
  font-size: 24px;
  align-items: center;
  display: flex;
  gap: 10px;
}

.price__cost-new {
  color: #FF0020;
  font-weight: 700;
}
.price__cost-old {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  text-decoration-line: line-through;
  color: #c5c7c6;
  margin-left: 4px;
}

.flat__btns {
  margin-bottom: 40px;
  align-items: center;
}

.flat__btns > .btn-small {
  padding: 10px 24px;
}

.flat__btns:last-child {
  margin-bottom: 0;
}

.flat__feats {
  max-width: 320px;
  margin-bottom: 40px;
}

.flat__feats:last-child {
  margin-bottom: 0;
}

.flat__mortgage {
  max-width: 325px;
  margin-bottom: 55px;
}

.flat__mortgage:last-child {
  margin-bottom: 0;
}

.plan__wrap {
  max-width: 668px;
  margin: 0 auto 50px;
}

.plan__sun {
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -324px;
  margin-left: -120px;
  pointer-events: none;
}

.plan__sun img {
  max-width: none;
}

:deep(.docs-button) {
  margin-top: 6px;
}

@media screen and (min-width: 1280px) {
  .flat__sidebar--curved div {
    width: 100%;
  }

  .flat__sidebar--curved div:nth-child(1) {
    margin-left: -40px;
  }
  .flat__sidebar--curved div:nth-child(2) {
    margin-right: -40px;
  }
  .flat__sidebar--curved div:nth-child(3) {
    margin-left: -40px;
  }
}
@media (max-width: 1279px) {
  .plan__wrap {
    margin-bottom: 0;
  }

  .flat__sidebar {
    width: 100%;
    height: auto;
    margin-top: 10px;
    flex-wrap: wrap;
  }

  .flat__sidebar::before {
    display: none;
  }

  .flat__trigger {
    margin: auto;
    margin-top: 20px;
  }
}
@media (max-width: 991px) {
  .flat {
    margin-bottom: 60px;
  }

  .flat__title {
    margin-bottom: 27px;
  }

  .flat__left {
    width: 100%;
    max-width: 510px;
    margin: 40px auto 0;
    padding: 0;
  }

  .flat__feats {
    max-width: 100%;
  }

  .flat__mortgage {
    max-width: 100%;
  }

  .plan__wrap {
    max-width: 510px;
  }

  .flat__sidebar {
    max-width: 510px;
    margin-top: 10px;
    margin-right: auto;
    margin-left: auto;
  }

  .flat__share {
    margin-left: 30px;
  }

  .flat__favourite {
    top: -4px;
  }
}
@media (max-width: 767px) {
  .flat__title {
    margin-bottom: 24px;
  }

  .flat__title.mb {
    margin-bottom: 8px;
  }

  /* .flat__tag {
    margin-bottom: 16px;
  } */

  .flat__info .info-small {
    font-size: 14px;
  }

  .col-lg-auto.order-lg-0 {
    margin-top: 40px;
  }

  :deep(.share) {
    position: static;
  }

  :deep(.share-btn__text) {
    display: none;
  }

  .price {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .price__label {
    margin-bottom: 10px;
  }

  .price__cost {
    flex-direction: column;
    align-items: flex-start;
  }

  .flat__favourite {
    position: static;
  }

  .docs-button__text {
    display: block;
  }
}
@media (max-width: 575px) {
  .flat__tags {
    margin-bottom: 24px;
  }

  .flat__share {
    margin: 0;
    /* margin: 16px 0 0; */
    /* flex: 1; */
    width: auto;
  }

  .price-buttons__mobile {
    display: flex;
    gap: 10px;
  }

  /* .flat__btns {
    margin-bottom: 16px;
  } */

  .flat__sidebar {
    width: 190px;
  }

  .plan__north {
    right: 0;
    left: auto;
    margin: 0;
  }

  .floor {
    top: 0;
  }

  :deep(.share.active .share__dropdown) {
    transform: translate(-120px, 4px);
  }

  :deep(.docs-button) {
    margin-top: 10px;
  }
}

@media (max-width: 375px) {
  .flat__left {
    margin-top: 30px;
  }

  .flat__btns .btn {
    width: 100%;
  }

  .flat__sidebar {
    margin-left: 0;
  }
}

.mortgage__mark {
  padding: 0 !important;
}

.active {
  cursor: pointer;
}
</style>
